import { Component, ElementRef, ViewChild, OnInit, Compiler} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import 'rxjs/add/operator/filter';
import { ConsigmentUploadService } from 'app/d2z/service/consignment-upload.service';
import { TrackingDataService } from 'app/d2z/service/tracking-data.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GridOptions } from "ag-grid";
declare var $: any;

@Component({
  selector: 'hms-sort-consignment',
  templateUrl: './sort-consignment.component.html',
  styleUrls: ['./sort-consignment.component.css']
})
export class SortConsignmentComponent implements OnInit{
  shipmentScanForm: FormGroup;
  childmenu: boolean;
  childmenuTwo:boolean;
  childmenuThree:boolean;
  childmenuFour:boolean;
  childmenuFive:boolean;
  manifestNumber: string;
  errorMsg: string;
  successMsg: String;
  show: Boolean;
  userName: String;
  role_id: String;
  consignmentList:any;
  public fieldArray: any[];
  page: number = 1;
  searchList: any;
  constructor(
    public consigmentUploadService: ConsigmentUploadService,
    public trackingDataService : TrackingDataService,
    private spinner: NgxSpinnerService,
    private _compiler: Compiler
  ) {
    this.show = false;
    this._compiler.clearCache();
  }

  onSelectionChange(){
    console.log("selected");
  }

  

  ngOnInit() {
    this.getConsignmentDetails();

    this.getLoginDetails();
  };

  getLoginDetails(){
    if(this.consigmentUploadService.userMessage != undefined){
      this.userName = this.consigmentUploadService.userMessage.userName;
      this.role_id = this.consigmentUploadService.userMessage.role_Id;
    }
  };

  onPageChange(newPage: number) {
    this.page = newPage;
  }
  
  getConsignmentDetails(){

    this.spinner.show();
    this.consigmentUploadService.getSortConsignment( (resp) => {
        // this.successMsg = resp.message;
        this.fieldArray=resp;
        this.spinner.hide();
        $('#outstandingEnquiry').modal('show');
    })
  }
  
  check(element){
    for (var fieldVal in this.fieldArray) {
            var fieldObj = this.fieldArray[fieldVal];
            fieldObj.checked = element.target.checked;
          }
        }

  onSbmit(){
    const obj=this.fieldArray.filter((x)=>x.checked==true);
    this.spinner.show();
    this.consigmentUploadService.updateSortedConsignment(obj, (resp) => {
        this.successMsg = resp.message;
        this.getConsignmentDetails();
        this.spinner.hide();
        $('#outstandingEnquiry').modal('show');
    })
  }
}





// WEBPACK FOOTER //
// ./src/app/d2z/views/superuser-level/create-shipment/sort-consignment/sort-consignment.component.ts